export const EMAIL = "vicksemmanuel58@gmail.com";
export const GITHUB = "https://github.com/vicksEmmanuel";
export const LINKEDIN = "https://www.linkedin.com/in/victor-u-04708316a/";
export const PHONE = "+44 7900 087608";
export const TWITTER = "";
export const SKILLS = [
  "Web Development",
  "Android & IOS Apps Development",
  "UI/UX",
  "Backend Development",
];

export const TechSkills = [
  "React-Native",
  "React",
  "Swift",
  "Python",
  "ARKit",
  "Firebase",
  "GraphQL",
  "SQL",
  "Docker",
  "NodeJS",
  "C# & .Net Core",
  "Digital Drawing",
  "JavaScript",
  "Angular",
  "TypeScript",
  "MongoDB",
  "Invision",
  "Webflow",
  "and More...",
];

export const NameText = "Hi there 👋🏼, my name is";
export const CareerText = "I am a";
export const HeroText =
  "With over 4 years software development experience, I have built ranges of products, " +
  "integrated with different teams, understood and used different techonologies " +
  "to produce web, mobile and desktop apps. \n" +
  "I am self motivated, constantly learning with the aim to improve. I deliver perfectly, " +
  "with my unique approach to problem solving. \nThank you.";
export const AnimationTime = 2;
